module.exports = __webpack_public_path__ + "media/soar-product-min.a89e39a1.mp4";